/**
 * useFreshSession
 *
 * Gate for any form whose SUBMIT is fresh-session-gated on the server (card capture, paid publish /
 * renew, subscribe). Probes freshness up front so a stale session is re-authenticated BEFORE the user
 * types anything, not after they submit. While the re-authentication prompt is up the probe never
 * settles, so the form stays unrendered. A probe failure other than "stale" (network, 5xx) lets the
 * form render: the server still enforces freshness on the real request.
 */

import { useQuery } from '@tanstack/react-query';
import { assertFreshSession } from '../lib/api';

export function useFreshSession(enabled = true): boolean {
  const { isSuccess, isError } = useQuery({
    queryKey: ['auth', 'session-fresh'],
    queryFn: async () => {
      await assertFreshSession();
      return true;
    },
    enabled,
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });
  return isSuccess || isError;
}
